<template>
  <MainLayout>
    <div class="auto-exchange-view">
      <div class="top-title">
        <h1>Resgatar brinde</h1>
      </div>

      <div class="exchange-progress">
        <div v-if="!error">
          <h2>{{ progressMessage }}</h2>
          <div class="progress-bar">
            <div class="progress-bar__fill" :style="{ width: progress + '%' }"></div>
          </div>
        </div>
        <div v-else class="exchange-error">
          <h2>{{ error }}</h2>
          <div class="exchange-actions">
            <button type="button" class="clean" @click="historyBack">Voltar</button>
            <button type="button" class="primary" @click="retry">Tentar novamente</button>
          </div>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "../layout/main";
import CampaignMixin from "../mixins/campaign.mixin.js";
import userMixin from "../mixins/user.mixin";

export default {
  mixins: [CampaignMixin, userMixin],
  components: {
    MainLayout,
  },
  data() {
    return {
      ticketId: null,
      ticket: null,
      progress: 5,
      progressMessage: "Carregando seu brinde...",
      error: "",
      isRunning: false,
      isDone: false,
    };
  },
  mounted() {
    this.ticketId = this.$route.params.id;
    this.start();
  },
  watch: {
    campaign() {
      this.start();
    },
  },
  methods: {
    setStep(progress, message) {
      this.progress = progress;
      this.progressMessage = message;
    },
    retry() {
      this.error = "";
      this.start();
    },
    fail(message) {
      this.error = message;
      this.isRunning = false;
    },
    async start() {
      if (this.isRunning || this.isDone || this.error) return;
      if (!this.campaign || !this.campaign.slug) return;
      this.isRunning = true;

      try {
        this.setStep(15, "Carregando seu brinde...");
        const ticketResponse = await this.getTicket(this.ticketId);
        if (!ticketResponse || !ticketResponse.ticket) return this.fail("Não foi possível carregar o brinde.");
        this.ticket = ticketResponse.ticket;

        if (this.ticket.status === "EXCHANGED" || this.ticket.status === "PRINTED") {
          return this.finish(this.ticket, this.ticket.product);
        }

        this.setStep(40, "Buscando brindes disponíveis...");
        const productResponse = await this.listProducts();
        const products = (productResponse && productResponse.product_list) || [];
        if (products.length === 0) return this.fail("Nenhum brinde disponível para resgate.");

        this.setStep(70, "Resgatando seu brinde...");
        const product = products[0];
        const response = await this.updateTicketStatus(this.ticket, product, "EXCHANGED");
        if (!response || !response.ticket) return this.fail("Não foi possível resgatar o brinde.");

        this.setStep(100, "Brinde resgatado!");
        this.finish(response.ticket, product);
      } catch (e) {
        this.fail("Não foi possível resgatar o brinde.");
      }
    },
    finish(ticket, product) {
      this.isDone = true;
      this.isRunning = false;
      const type = (ticket.product && ticket.product.type) || (product && product.type);
      const path = type === "GIFT_CARD" ? "/gift-card/" + ticket._id : "/cupons";
      this.$router.replace(this.campaignHome + path);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../scss/colors.scss";

.exchange-progress {
  padding: 0 24px;

  h2 {
    text-align: center;
    margin-top: 20%;
    font-size: 15pt;
    color: var(--primary);
    margin-bottom: 20px;
  }

  .progress-bar {
    width: 100%;
    max-width: 320px;
    height: 10px;
    margin: 0 auto;
    border-radius: 6px;
    background: $gray-light;
    overflow: hidden;
  }

  .progress-bar__fill {
    height: 100%;
    border-radius: 6px;
    background: var(--primary, $primary);
    transition: width 0.4s ease;
  }

  .exchange-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
  }
}
</style>
